import React, { useEffect, useState } from "react";
import CardBox from "../common/CardBox";
import { Link } from "react-router-dom";
import {
  Avatar,
  Button,
  Card,
  DatePicker,
  Flex,
  Form,
  GetProp,
  Grid,
  Input,
  Select,
  Space,
  Table,
  TableProps,
  Tag,
  Typography,
} from "antd";
import {
  SearchOutlined,
  CloseOutlined,
  PlusOutlined,
  HomeOutlined,
  HomeTwoTone,
  ShopOutlined,
  CoffeeOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { ColumnsType, SorterResult } from "antd/es/table/interface";
import qs from "qs";
import CommonDataTable from "../common/CommonDataTable";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { ChevronUp, ChevronDown } from "lucide-react";

interface DataType {
  name: {
    first: string;
    last: string;
  };
  gender: string;
  email: string;
  login: {
    uuid: string;
  };
}

interface TableParams {
  pagination?: any;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const { Title, Text } = Typography;
const columns: ColumnsType<DataType> = [
  {
    title: "Booking Number",
    dataIndex: "booking_number",
    sorter: true,
    render: (booking_number) => `${booking_number}`,
    width: "20%",
  },
  {
    title: "Email",
    dataIndex: "email",
    filters: [
      { text: "Male", value: "male" },
      { text: "Female", value: "female" },
    ],
    width: "20%",
  },
  {
    title: "Customer Name",
    dataIndex: "text",
  },
  {
    title: "Created On",
    dataIndex: "text",
  },
  {
    title: "Booking Status",
    dataIndex: "text",
  },
  {
    title: "",
    dataIndex: "Action",
  },
];

const getRandomuserParams = (params: TableParams) => ({
  results: params.pagination?.pageSize,
  page: params.pagination?.current,
  ...params,
});

const SearchBooking = () => {
  const [form] = Form.useForm();
  const [clientReady, setClientReady] = useState<boolean>(false);

  // To disable submit button at the beginning.
  useEffect(() => {
    setClientReady(true);
  }, []);

  const onFinish = (values: any) => {
    console.log("Finish:", values);
  };
  const [isVisible, setIsVisible] = useState(false);
  return (
    <>
      <Form
        form={form}
        name="search_booking"
        className="gap-16"
        layout="inline"
        onFinish={onFinish}
      >
        <Form.Item
          className="filterTextfieldBox"
          label="Agent/SubAgent Details"
          rules={[
            { required: true, message: "Please input your search keywords!" },
          ]}
        >
          <Select
            className="searchInputField"
            defaultValue="Booking Date"
            suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
            options={[
              { value: "All", label: "All" },
              { value: "Agent", label: "Agent" },
              { value: "AGT-0908", label: "AGT-0908" },
              { value: "Sub Agent", label: "Sub Agent" },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Booking Ref. No."
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input className="searchInputField" />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="Service"
          rules={[
            { required: true, message: "Please input your search keywords!" },
          ]}
        >
          <Select
            className="searchInputField"
            defaultValue="Booking Date"
            suffixIcon={<FontAwesomeIcon icon={faCaretDown} />}
            options={[
              { value: "All", label: "All" },
              { value: "Hotel", label: "Hotel" },
              { value: "Activities", label: "Activities" },
              { value: "Meal", label: "Meal" },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="filterTextfieldBox"
          label="From Date"
          rules={[{ required: true, message: "Please select created from!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>

        <Form.Item
          className="filterTextfieldBox"
          label="To Date"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <DatePicker className="searchInputField" />
        </Form.Item>

        <Form.Item className="d-flex align-end mr-0">
          <Button type="primary" size="large" danger className="px-5">
            View report
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

const BookingData = () => {
  const navigate = useNavigate();

  const onRowClick = (event: any) => {
    navigate("/home/booking/edit");
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const setAgeSort = () => {
    setSortedInfo({
      order: "descend",
      columnKey: "age",
    });
  };
  const clearFilters = () => {
    setFilteredInfo({});
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Booking No.",
      dataIndex: "bookingNo",
      key: "bookingNo",
    },
    {
      title: "Booking Date",
      dataIndex: "bookingDate",
      key: "bookingDate",
    },
    {
      title: "Passenger Name",
      dataIndex: "passengerName",
      key: "passengerName",
    },
    {
      title: "Service",
      dataIndex: "service",
      key: "service",
    },
    {
      title: "Check In",
      dataIndex: "checkIn",
      key: "checkIn",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Agt/Sub",
      dataIndex: "agtSub",
      key: "agtSub",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "View",
      dataIndex: "view",
      key: "view",
    },
  ];

      const columnsMobile = [
        {
          dataIndex: "details",
          key: "details",
          render: (_: any, record: any) => {
            // Filter out 'adult', 'child', and 'infant' if their value is "0"
            const filteredData = Object.entries(record).filter(([key, value]) => {
              return !(
                (key === "adult" || key === "child" || key === "infant") &&
                value === "0"
              );
            });
      
            return (
              <div className="mobile-card">
                {filteredData.map(([key, value]) => {
                  // Show bookingDate and travelDate in one row
                  if (key === "bookingDate") {
                    return (
                      <p key={key}>
                        <strong>Booking & Travel Date: </strong>
                        {value} → {record.travelDate}
                      </p>
                    );
                  }
                  if (key === "travelDate") return null; // Hide separate travelDate entry
      
                  return (
                    <p key={key}>
                      <strong>{key.replace(/([A-Z])/g, " $1")}: </strong>
                      {React.isValidElement(value) ? value : String(value)}
                    </p>
                  );
                })}
              </div>
            );
          },
        },
      ];

  const data = [
    {
      key: "1",
      bookingNo: "John Brown",
      passengerName: "AGT-900",
      service: "New York No. 1 Lake Park",
      checkIn: "ETMKT980990",
      amount: "Mr. Gharju",
      agtSub: "2",
      status: "0",
      view: "",
    },
    {
      key: "2",
      bookingNo: "John Brown",
      passengerName: "AGT-900",
      service: "New York No. 1 Lake Park",
      checkIn: "ETMKT980990",
      amount: "Mr. Gharju",
      agtSub: "2",
      status: "0",
      view: "",
    },
  ];
  const { useBreakpoint } = Grid; // Correct way to use it
  const screens = useBreakpoint(); // Ensures screens is defined
  return (
    <>
      <Table
        bordered
        columns={screens.lg ? columns : columnsMobile}
        dataSource={data}
        onChange={handleChange}
        className="mt-4 responsiveTable"
      />
    </>
  );
};

export const Vouchers = () => {
  const [searchBookingIsVisible, setSearchBookingIsVisible] = useState(false);
  return (
    <CardBox
      title={
        <Typography.Title
          level={2}
          color="danger"
          className="mb-0 mt-0 primary-color font-weight-700"
        >
          Report &nbsp;
          <Text type="danger" className="header-font-title">
            Vouchers{" "}
          </Text>
        </Typography.Title>
      }
    >
      <div
        className={`drawer-box ${searchBookingIsVisible ? "drawerActive" : ""}`}
      >
        <Card className="topBox transition-all duration-300 ease-in-out">
          <SearchBooking />
        </Card>

        <Button
          className="slideButton"
          onClick={() => setSearchBookingIsVisible(!searchBookingIsVisible)}
        >
          {searchBookingIsVisible ? (
            <ChevronUp size={20} />
          ) : (
            <ChevronDown size={20} />
          )}
        </Button>
      </div>

      <Text type="secondary" className="d-block mb-2">
        Showing 1 to 10 of 800 records
      </Text>
      <BookingData />
    </CardBox>
  );
};

export default Vouchers;
